import { memo } from 'react';

import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import styles from './SearchKnmPanelFilters.module.scss';

interface IKnmSearchFilterObjectProps {
  filterName: string;
  filterValue: ISelectOption;
  removeFilterValue: () => void;
}

export const KnmSearchFilterObject = memo(
  ({ filterName, filterValue, removeFilterValue }: IKnmSearchFilterObjectProps) => (
    <div className={styles.FilterWrap}>
      {filterName && <div className={styles.FilterLabel}>{filterName}</div>}
      {filterValue.label && (
        <div className={styles.FilterTextWrap}>
          <div className={styles.FilterText}>{filterValue.label}</div>
          <div className={styles.FilterRemove} onClick={removeFilterValue} />
        </div>
      )}
    </div>
  ),
);
